import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const columns = [{
  title: 'Sin preguntas',
  copy: 'No pedimos explicaciones'
}, {
  title: 'Sin formularios',
  copy: 'Solo un correo electrónico'
}, {
  title: 'Devolución en 24h',
  copy: 'Rápido y sin drama'
}];
export function GuaranteeSection() {
  return <section className="bg-mp-dark py-20 md:py-24" data-id="element-161" data-mp="jrr6j30h63td">
      <Container data-id="element-162" data-mp="nu49xkrr1pmz">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto max-w-[820px] rounded-2xl border border-mp-lime/30 bg-mp-card p-8 text-center md:p-12" data-id="element-163" data-mp="ntm4pyn4012x">
          <span className="text-5xl" role="img" aria-label="Escudo de garantía" data-id="element-164" data-mp="12kl8mwd021g6">
            🛡️
          </span>

          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-165" data-mp="17g0otuyhc9fr">
            Garantía total de 14 días
          </h2>
          <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-lime md:text-base" data-id="element-166" data-mp="20rsqmrp95p64">
            Si no es para ti, te devolvemos el 100%.
          </p>

          <div className="mx-auto mt-6 max-w-[600px] space-y-1 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-167" data-mp="1rsfetsdnooi8">
            <p data-id="element-168" data-mp="2oioexeui228m">Prueba el material sin ningún riesgo.</p>
            <p data-id="element-169" data-mp="2okiyopu1bob4">Revisa los 5 tomos. Usa las fichas en pista.</p>
            <p data-id="element-170" data-mp="2jkmw8v0zk4xo">
              Si en 14 días no sientes que Maestro en Pista ha mejorado tu forma de planificar y dar clases,
              escríbenos y te devolvemos el importe completo en menos de 24 horas.
            </p>
            <p className="pt-2 font-medium text-mp-white" data-id="element-171" data-mp="2aqrsnrfiimk5">Sin formularios. Sin preguntas. Sin drama.</p>
          </div>

          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-172" data-mp="37ar2la5k6isd">
            {columns.map(col => <div key={col.title} className="rounded-xl border border-mp-border bg-mp-dark p-5" data-id="element-173" data-mp="10knqsbhrsusq">
                <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-174" data-mp="15jqr5imt2cud">{col.title}</p>
                <p className="mt-1 text-xs text-mp-gray md:text-sm" data-id="element-175" data-mp="qv42gqbag8qh">{col.copy}</p>
              </div>)}
          </div>
        </motion.div>
      </Container>
    </section>;
}